import '../../Assets/Styles/register.css';
import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { Divider } from 'primereact/divider';
import { Panel } from 'primereact/panel';
import { Password } from 'primereact/password';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Skeleton } from 'primereact/skeleton';
import { Message } from 'primereact/message';
import { Menu } from 'primereact/menu';
import { SpeedDial } from 'primereact/speeddial';
import { Toast } from 'primereact/toast';

import moment from "moment";
import 'moment/locale/pt-br';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

// Load Actions
import * as AppActions from '../../Store/Actions/App';
import * as ReservationActions from '../../Store/Actions/Reservation';
import * as OrderActions from '../../Store/Actions/Order';

// Load Components
import AlertView from '../../Components/AlertModal';
import ValidateView from '../../Components/ValidateModal';

// Lodad Cancel Reservation Modal
import ReservationCancelModal from './ReservationCancelModal';
import ReservationPayModal from './ReservationPayModal';

import iconResponsibleWarning from '../../Assets/Images/iconResponsibleWarn.svg';

import {
	validarCNPJ,
	validarCPF,
	validarEmail,
	validarTelefone,
	validarNome,
	maskCNPJ,
	maskCPF,
	maskPhone,
	formatNumberCurrency
} from '../../Components/Utils';


// Set main array
const itemsList = [
	{
		label: 'Ações disponíveis',
		items: [
			{
				label: 'Aprovar cadastro',
				icon: 'pi pi-check green',
				command: () => {
					console.log("OK");
				}
			},{
				label: 'Reprovar cadastro',
				icon: 'pi pi-ban red',
				command: () => {
					console.log("OK");
				}
			},{
				label: 'Colocar em análise',
				icon: 'pi pi-info orange',
				command: () => {
					//reviewConfirm()
					console.log("OK");
				}
			},{
				label: 'Excluir cadastro',
				icon: 'pi pi-times',
				command: () => {
				console.log("OK");
				}
			}
		]
	}
];	

// UpdateService dialog component
const ReservationView = (props) => {

// set vars from props
const { 
	dialog,
	setDialog,
	updateReservation,
	executeReservationAction,
	selectedReservation,
	scrollBlock,
	masterUser,
	retrieveReservation,
	downloadQuotePdf,
	onReloadDataList,
	userRights
} = props;		

// Define Refs
const menuLeft = React.useRef(null);

// Loaders
const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 
const [loadingData, setLoadingData] = React.useState(true); 

// Reservation Data
const [companyLegalName, setCompanyLegalName] = React.useState('');
const [companyFantasyName, setCompanyFantasyName] = React.useState('');
const [companyEmail, setCompanyEmail] = React.useState('');
const [companyPhone, setCompanyPhone] = React.useState('');
const [companyState, setCompanyState] = React.useState('');
const [companyCity, setCompanyCity] = React.useState('');
const [personCompanyName, setPersonCompanyName] = React.useState('');

const [acceptTerm, setAcceptTerm] = React.useState(false);

// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertAction, setAlertAction] = React.useState(""); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 

const [navigationOption, setNavigationOption] = React.useState(null);

// Status control to reflect interface
const [bookingStatus, setBookingStatus] = React.useState(1); // 0 - waiting confirmation | 1 - confirmed | 2 - cancelled by system | 3 - cancelled by agency
const [paymentStatus, setPaymentStatus] = React.useState(0); // 0 - waiting confirmation | 1 - Payment confirmed | 2 - Waiting Refund	| 3 - Refund confirmed
const [cancelStatus, setCancelStatus] = React.useState(0); // 0 - no payment | 1 - payment and cancel within limite date | 2 - payment and cancel after limite date / within provider date | 3 - payment and cancel after provider date | 4 - Cancel after checkin date
const [refundStatus, setRefundStatus] = React.useState(0); // 0 - no refund | 1 - refund generated and waiting refund | 2 - refund generated and paid | 3 - refund created manually and waiting refund | 4 - refund created manually and paid
const [comissionStatus, setComissionStatus] = React.useState(0); // 0 - comission estimatimated, no payment yet | 1 - booking paid, commission generated and waiting payment | 2 - booking paid, commission generated and paid | 3 - No comission, booking paid, antecipated | 4 - Comission cancelled due to booking cancel | 5 - Comission refund due, agency need to pay end customer (booking cancelled after comission beign paid)
 
const [paymentMethod, setPaymentMethod] = React.useState("cc"); // cc - credit card | bcc - business credit card | pix - pix  | other
const [paymentManualConfirmation, setPaymentManualConfirmation] = React.useState(0); // 0 - no confirmation | 1 - manual confirmation
const [checkinDate, setCheckinDate] = React.useState(new Date());

// Set menu control and itens
const [menuItems, setMenuItems] = React.useState(itemsList); // Menu actions Items
const [navigationOptionsShortcut, setNavigationOptionsShortcut] = React.useState([]);

// Interface control
const [bookingHistoryPanel, setBookingHistoryPanel] = React.useState(false);
const [paymentHistoryPanel, setPaymentHistoryPanel] = React.useState(false);
const [bookingHistory, setBookingHistory] = React.useState([]);
const [paymentHistory, setPaymentHistory] = React.useState([]);
const [loadingQuote, setLoadingQuote] = React.useState(false);

const [paymentResponsibleHistory, setPaymentResponsibleHistory] = React.useState([]);
const [paymentResponsibleHistoryPanel, setPaymentResponsibleHistoryPanel] = React.useState(false);


// Dados crus da API para usarmos na tela
const [reservation, setReservation] = React.useState(null);

// Conveniências já “derivadas” do payload
const reservationAll = reservation || null;
const booking = reservation?.booking || null;
const latestPayment = reservation?.latestPayment || null;
const refund = reservation?.refund || null;
const totals = reservation?.totals || null;
const responsiblePayer = reservation?.responsiblePayer || null;
const guests = reservation?.guests || [];
const hotel = reservation?.hotel || null;
const history = (booking?.history ?? []);
const historyPayment = (latestPayment?.history ?? []).slice().reverse();
const comission = reservation?.commission || null;
const blockPayment = (reservation?.responsiblePayer?.isOneOfGuests === false && reservation?.applyPaymentRestrictions === true) ? true : false;


// ---- Cancel Reservation Modal (local UI state) ---- //
const [cancelDialog, setCancelDialog] = React.useState(false);

// Pay Reservation Modal (local UI state) //
const [payDialog, setPayDialog] = React.useState(false);


// console.log('[reservationAll]--------->]'+JSON.stringify(reservationAll, null, 2));
// console.log('[historyPayment]--------->]'+JSON.stringify(historyPayment, null, 2));


// useRef 
const toast = React.useRef(null);

/* Activate Success Toast  */
const showSuccess = (title="",message="") => {
	toast.current.show({severity:'success', summary: title, detail:message, life: 6000});
}

/* Activate Error Toast  */
const showError = (title="",message="") => {
	toast.current.show({severity:'error', summary: title, detail:message, life: 6000});
}

/* Activate Warning Toast  */
const showWarning = (title="",message="") => {
	toast.current.show({severity:'warn', summary: title, detail:message, life: 6000});
}

var loadingTimer = null;		

const handleTermsChange = (e) => {
	if (e.checked)
		setAcceptTerm(true);
	else
		setAcceptTerm(false);
}  // end function

const retrieveReservationInfo = () => {
	
	setLoadingData(true);
	
	var props = {
		setSaving:setSaving,
		setAlert:setAlert,
		setAlertTitle:setAlertTitle,
		setAlertBody:setAlertBody,
		setLoadingData:setLoadingData
	}
	var data = {
	  reservationId: selectedReservation.reservationId
	}
	retrieveReservation(data,props);

} // end retrieveDocumentInfo

/* Reset form fields and close dialog */
const closeDialog = () => {
	
	// Reset form fields
	// ...

	// close dialog
	setDialog('reservationModal',false);

	// Clear Timeout
	clearTimeout(loadingTimer);

	setTimeout(function() {
				
		if (scrollBlock) {
			document.body.classList.add('p-overflow-hidden');	
		} // end if
	},300);
		
}

// Execute when component opens
React.useEffect(() => {

	// Enter and closes modal
	setDialog('reservationModal',false);
	setCancelDialog(false);
	setPayDialog(false);

},[]);

// Execute when dialog opens
React.useEffect(() => {

	// Only runs when  dialog opens
	if (dialog.target == 'reservationModal' && dialog.status) {

		// Retrieve current reservation
		// retrieveReservationInfo();
		executeRetrieveOrder();

		// close cancel dialog
		setCancelDialog(false);
		setPayDialog(false);

		setNavigationOption(null);

	} // end if
	else {
		
		// Clear Timeout
		clearTimeout(loadingTimer);
		
	} // end else
	
	// Reset all fields when closes or open dialog
	// When closes
    return () => {
      
		setNavigationOption(null);
		
		// Clear Timeout
		clearTimeout(loadingTimer);
						
		setTimeout(function() {
			if (scrollBlock) {
				document.body.classList.add('p-overflow-hidden');	
			} // end if
		},300);		
		
    };	
			
},[dialog]);

// set menu itens
React.useEffect(() => {

	// Set action menu according to payment and bookingStatus
	let itemsArray = [];

	// add Pay Now item
	if (paymentStatus == 0 && bookingStatus == 1 && !masterUser) {
		if (userRights.includes('payBooking') || userRights.includes('all')) {
			itemsArray.push({
					label: 'Pagar Reserva',
					icon: 'pi pi-dollar',
					command: () => {
						setPayDialog(true);
					}
			});
		}
	}
	// add Cancel Reservation item
	if (bookingStatus == 1) {
		if (userRights.includes('cancelBooking') || userRights.includes('all')) {
			itemsArray.push({
					label: 'Cancelar reserva',
					icon: 'pi pi-times',
					command: () => {
						setCancelDialog(true);
					}
			});
		}
	}
	// add Download PDF Voucher item
	if (paymentStatus == 1 && bookingStatus == 1) {
		itemsArray.push({
				label: 'Gerar PDF Voucher',
				icon: 'pi pi-download',
				command: () => {
					handleDownloadVoucher();
				}
		});
	}
	// add Download PDF Confirmation item
	if (paymentStatus == 0 && bookingStatus == 1) {
		itemsArray.push({
				label: 'Gerar PDF Confirmação',
				icon: 'pi pi-download',
				command: () => {
					handleDownloadVoucher('receipt');
				}
		});
	}
	// add Report No-show item
	/*if (checkinDate > new Date() && bookingStatus == 1 && paymentStatus == 1) {
		if (userRights.includes('informNoShow') || userRights.includes('all')) {
			itemsArray.push({
				label: 'Informar No-show',
				icon: 'pi pi-calendar-times',
				command: () => {
					console.log("OK");
				}
			});
		}
	}*/

	// MasterUser Actions ----- //
	// add Change Payment Responsible item
	if (paymentStatus == 0 && masterUser && bookingStatus == 1) {
		if (userRights.includes('updatePaymentLimitation') || userRights.includes('all')) {
			itemsArray.push({
					label: 'Retirar restrições para pagamento',
					icon: 'pi pi-times',
					command: () => {
						console.log("OK");
					}
			});
		}
	}	
	// add Change Payment Responsible item
	if (paymentStatus == 0 && masterUser && bookingStatus == 1) {
		if (userRights.includes('updatePaymentResponsible') || userRights.includes('all')) {
			itemsArray.push({
					label: 'Alterar responsável pelo pagamento',
					icon: 'pi pi-user-edit',
					command: () => {
						console.log("OK");
					}
			});
		}
	}
	// add Create Refund item
	if ((bookingStatus == 3 && refundStatus == 0 && paymentStatus == 1) && masterUser) {
		if (userRights.includes('createRefund') || userRights.includes('all')) {
			itemsArray.push({
					label: 'Criar reembolso',
					icon: 'pi pi-plus',
					command: () => {
						console.log("OK");
					}
			});
		}
	}
	// add Delete Refund item
	if ((bookingStatus == 3 && refundStatus == 3) && masterUser) {
		if (userRights.includes('cancelCreatedRefund') || userRights.includes('all')) {
			itemsArray.push({
					label: 'Excluir Reembolso',
					icon: 'pi pi-times',
					command: () => {
						console.log("OK");
					}
			});
		}
	}
	// add pay refund if PIX
	if (bookingStatus == 3 && paymentStatus == 2 && masterUser && paymentMethod == "pix") {
		if (userRights.includes('confirmRefund') || userRights.includes('all')) {
			itemsArray.push({
					label: 'Dar baixa em reembolso',
					icon: 'pi pi-check-circle',
					command: () => {
						console.log("OK");
					}
			});
		}
	}

	// add refund payment if cc or bcc (business credit card)
	if (bookingStatus == 3 && paymentStatus == 2 && masterUser && (paymentMethod == "cc" || paymentMethod == "bcc")) {
		if (userRights.includes('executeRefund') || userRights.includes('all')) {
			itemsArray.push({
					label: 'Efetivar reembolso',
					icon: 'pi pi-check-circle',
					command: () => {
						console.log("OK");
					}
			});
		}
	}

	// add payment confirm action
	if (paymentStatus == 0 && bookingStatus == 1 && masterUser) {
		if (userRights.includes('confirmPayment') || userRights.includes('all')) {
			itemsArray.push({
					label: 'Baixar pagamento',
					icon: 'pi pi-check-circle',
					command: () => {
						console.log("OK");
					}
			});
		}
	}
	// add Cancel Payment Download item
	if (paymentStatus == 1 && paymentManualConfirmation == 1 && masterUser) {
		if (userRights.includes('cancelConfirmPayment') || userRights.includes('all')) {
			itemsArray.push({
					label: 'Cancelar baixa de pagamento',
					icon: 'pi pi-times',
					command: () => {
						console.log("OK");
					}
			});
		}
	}
	// add comission confirmation
	if (paymentStatus == 1 && comissionStatus == 1 && masterUser) {
		if (userRights.includes('confirmCommissionPayment') || userRights.includes('all')) {
			itemsArray.push({
					label: 'Confirmar pagamento de comissão',
					icon: 'pi pi-check-circle',
					command: () => {
						console.log("OK");
					}
			});
		}
	}
	// add Cancel Commission Payment Download item
	if (paymentStatus == 1 && comissionStatus == 2 && masterUser) {
		if (userRights.includes('cancelConfirmCommissionPayment') || userRights.includes('all')) {
			itemsArray.push({
					label: 'Cancelar confirmação de pagamento de comissão',
					icon: 'pi pi-times',
					command: () => {
						console.log("OK");
				}
			});
		}
	}

	setMenuItems(itemsArray);

	// Set navigation shortcut array
	let navigationShortcutArray = [];
	navigationShortcutArray.push({ label: 'Ir para o topo', code: 'topSection' });
	navigationShortcutArray.push({ label: 'Dados da reserva', code: 'bookingData' });
	navigationShortcutArray.push({ label: 'Resumo das seleções', code: 'selectionSummary' });
	navigationShortcutArray.push({ label: 'Responsável pelo pagamento', code: 'paymentResponsibleData' });
	navigationShortcutArray.push({ label: 'Relação de Hóspedes', code: 'guestsData' });
	navigationShortcutArray.push({ label: 'Informações do pagamento', code: 'paymentData' });
	navigationShortcutArray.push({ label: 'Informações da Comissão', code: 'paymentCommissionData' });
	setNavigationOptionsShortcut(navigationShortcutArray);

},[reservation]);


const handleClickScroll = (target,displacement=70) => {
		
	const element = document.getElementById(target);
	if (element) {
		// 👇 Will scroll smoothly to the top of the next section
		var elementPosition = element.offsetTop - displacement;
		element.scrollIntoView({ top: elementPosition,behavior: 'smooth' });
	}
};  


// Modal footer 	
const footerContent = (
	<div className="modalFooterButtons" style={{}}>
	
		<div className="modalFooterButtonsLeft" style={{height:"50px"}}>
			<div className="flex-row justify-start align-items-center" style={{position:"relative",height:"100%"}}>
				
				{(menuItems.length > 0 && !loadingData) && <SpeedDial showIcon="pi pi-bars" hideIcon="pi pi-times" className="speeddial-with-labels bottom-0 right-0" label="Ações disponíveis" model={menuItems} style={{position:"absolute",bottom:"0",left:"0"}} direction="up" />}

				{/*<Menu model={menuItems} popup ref={menuLeft} id="popup_menu_left" style={{minWidth:"230px",justifyContent:"center",alignItems:"center"}} />
			<Button label="Abrir ações" icon="pi pi-align-left" severity="secondary" className="mr-2" onClick={(event) => menuLeft.current.toggle(event)} aria-controls="popup_menu_left" aria-haspopup />*/}


			</div>
		</div>
		<div className="modalFooterButtonsRight">
			<Button label="Fechar" disabled={saving} icon="pi pi-times" className="p-button-text" onClick={() => closeDialog()} />
			{/*<Button label="Cadastrar" icon="pi pi-check" loading={saving} onClick={() => update()} />*/}
		</div>
		
	</div>
);		


const headerTemplate = (
	<>
		<div className="flex-row align-items-center justify-start">
			<div className="flex-1">
				<h2 className="m-0" style={{fontSize:"1.2rem",margin:"0"}}>Visualização da Reserva #{selectedReservation?.reservationId ?? "carregando..."}</h2>
			</div>
			<div>
				{/* Activate handleClickScroll based on selected value */} 
				<Dropdown value={navigationOption} options={navigationOptionsShortcut} onChange={(e) => {
					handleClickScroll(e.value?.code || "topSection");
				}} placeholder="Atalho de Navegação" style={{width:"250px",marginRight:"2rem"}} />
			</div>
		</div>
	</>
);


// Handle download voucher PDF
const handleDownloadVoucher = async (type='voucher') => {

  setLoadingQuote(true);

  // dOWNLOAD STARTED
   toast.current.show({ severity: 'info', summary: 'Gerando cotação', detail: 'O PDF está sendo gerado, por favor aguarde...', life: 4000 });

  const data = generateVoucherInfo();

  const result = await downloadQuotePdf(data,type); 

  setTimeout(() => {
		
		setLoadingQuote(false)

		if (result.success) {
			showSuccess("Pronto!", "Escolha o nome e baixe o arquivo.");
		} else {
			toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Falha ao gerar PDF.', life: 4000 });
		}
  	}, 2000);


};  

// HELPER Generate voucher info for PDF
// HELPER Generate voucher info for PDF (versão integrada ao payload do endpoint)
const generateVoucherInfo = () => {

  const r = reservation; // preenchido no executeRetrieveOrder
  if (!r) return null;

  // atalhos seguros
  const booking = r.booking || {};
  const hotel = r.hotel || {};
  const rooms = Array.isArray(hotel.rooms) ? hotel.rooms : [];
  const room0  = rooms.length ? rooms[0] : null;
  const totals = r.totals || {};
  const dest   = r.destination || {};
  const payer  = r.responsiblePayer || {};

  // helpers de fallback
  const safeJoin = (arr, sep = ", ") => (Array.isArray(arr) ? arr.filter(Boolean).join(sep) : "");
  const fmt = (amt, ccy) => {
    // usa seu formatador se existir
    if (typeof formatNumberCurrency === "function" && amt != null && ccy) {
      return `${formatNumberCurrency(Number(amt), String(ccy).toUpperCase())}`;
    }
    // fallback simples
    return (amt != null && ccy) ? `${Number(amt).toFixed(2)} ${String(ccy).toUpperCase()}` : "";
  };

  // HOTEL / DETALHES
  const hotel_name =
    [hotel?.name, dest?.display || safeJoin([dest?.country, dest?.city], ", ")].filter(Boolean).join(" - ") || "N/A";

  const booking_period =
    booking?.period?.display ||
    (booking?.period?.checkin && booking?.period?.checkout
      ? `${moment(booking.period.checkin).format("DD/MM/YYYY")} a ${moment(booking.period.checkout).format("DD/MM/YYYY")}`
      : "N/A");

  const booking_number =
    booking?.reservationCode || booking?.confirmationCode || r.internalCode || "N/A";

  const hotel_address =
    [hotel?.address, dest?.city, dest?.country].filter(Boolean).join(", ") || "-";

  // contatos do hotel — payload não traz garantido; deixo em branco com fallback
  const hotel_contact = {
    tel: hotel?.phone || "",
    email: hotel?.email || "",
    site: hotel?.external?.bookingComUrl || ""
  };

  const hotel_checkin  = hotel?.checkinTime || "15:00 (confirmar com o hotel)";
  const hotel_checkout = hotel?.checkoutTime || "12:00 (confirmar com o hotel)";
  const hotel_min_age_checkout = hotel?.min_age_checkout || "18";

  // POLÍTICAS E PRAZOS
  const cancellation_deadline =
    room0?.cancelPolicy?.untilDisplay ||
    booking?.deadlines?.freeCancelDateDisplay ||
    "";

  const cancellation_policy =
    room0?.cancelPolicy?.text || "";

  // TOTAIS / VALORES
  // total_amount: “Total com taxas locais” (payWithFeesDisplay já vem pronto: ex. "USD$ 313.97 + 20.00 EUR")
  const total_amount = totals?.payWithFeesDisplay || "";

  // total_booking: “Pagar agora” (gateway)
  const total_booking = totals?.payNowDisplay || "";

  // total_local: taxas a pagar na propriedade (apenas fees locais)
  const total_local = totals?.payAtPropertyDisplay || "0";

  // additional_fees: detalhamento de taxas locais por item (se vierem por quarto)
  const additional_fees = Array.isArray(room0?.localCollectedFees)
    ? room0.localCollectedFees
        .filter(f => f && f.amount != null)
        .map(f => ({
          name: f.description || "Taxa local",
          value: fmt(f.amount, f.currency)
        }))
    : [];

  // QUARTO / HÓSPEDES
  const room = {
    title: room0?.name || "Quarto",
    room_name: room0?.name || "", // mantendo ambos por compat
    room_responsible_name: payer?.fullName || "",
    room_hosts_label: room0?.guestsSummary || "",
    room_extra: (Array.isArray(room0?.extras) && room0.extras.length)
      ? safeJoin(room0.extras, " • ")
      : "Nenhum extra incluído",
    room_additional_info: room0?.specialRequests || ""
  };

  // RESPONSÁVEL PELO PAGAMENTO
  const bookingPaymentResponsible = {
    completeName: payer?.fullName ?? "",
    email: payer?.email ?? "",
    mobilePhone: payer?.phone ?? ""
  };

  // monta objeto final no formato que seu gerador de PDF espera
  const data = {
    hotel_name,
    booking_period,
    booking_number,
    hotel_address,
    hotel_contact,
    hotel_checkin,
    hotel_checkout,
    hotel_min_age_checkout,
    cancellation_deadline,
    cancellation_policy,
    total_amount,
    total_booking,
    total_local,
    additional_fees,
    room,
    bookingPaymentResponsible
  };

  return data;
};


const executeRetrieveOrder = async () => {
  try {
    setLoadingData(true);

    // Chama a action desacoplada
    const resp = await retrieveReservation(
      { bookingId: selectedReservation?.reservationId }
    );

    if (!resp?.success || !resp?.data?.reservation) {
      setAlert(true);
      setAlertTitle("Ops! Não foi possível carregar a reserva");
      setAlertBody(resp?.error || "Tente novamente em instantes.");
      setLoadingData(false);
      return;
    }

    const r = resp.data.reservation;
    setReservation(r);

    // Sincroniza seus estados de interface existentes (mantendo regras já usadas)
    setBookingStatus(Number(r?.booking?.status ?? 0));
    setPaymentStatus(Number(r?.latestPayment?.status ?? 0));
    setCancelStatus(Number(r?.booking?.cancellation?.cancelStatus ?? 0));
    setRefundStatus(Number(r?.refund?.status ?? 0));
    setComissionStatus(Number(r?.commission?.status ?? 0));
    setPaymentMethod(r?.latestPayment?.method || "cc");
    setPaymentManualConfirmation(r?.latestPayment?.manualConfirmation ? 1 : 0);

    // Check-in para regras de menu (no-show etc.)
    if (r?.booking?.period?.checkin) {
      setCheckinDate(new Date(r.booking.period.checkin));
    }

    // Históricos (usados nos toggles de painel)
    setBookingHistory(Array.isArray(r?.booking?.history) ? r.booking.history : []);
    setPaymentHistory(Array.isArray(r?.latestPayment?.history) ? r.latestPayment.history : []);

    // Histórico do responsável (a UI já tem painel próprio)
    setPaymentResponsibleHistory(
      Array.isArray(r?.responsiblePayer?.history) ? r.responsiblePayer.history : []
    );

    setLoadingData(false);
  } catch (e) {
    setAlert(true);
    setAlertTitle("Erro inesperado");
    setAlertBody(e?.message || "Tente novamente.");
    setLoadingData(false);
  }
};


	return (
	<>
			<Dialog header={headerTemplate} visible={dialog.target == 'reservationModal' && dialog.status} style={{ width: '75vw',height:"95vh" }} breakpoints={{ '1400px': '75vw','960px': '80vw', '641px': '100vw' }} onHide={() => closeDialog()} footer={footerContent} blockScroll={true} maximizable={saving ? false : true} closable={saving ? false : true} closeOnEscape={true} >
			
				<Box
				  sx={{
					width: "100%",
				  }}
				>
				
				{/* LOADING  */}
				{loadingData &&
					<>
						<div style={{backgroundColor:"transparent", width:"100%",maxWidth:"1170px", marginTop:"30px",marginBottom:"50px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
						
								<ProgressSpinner style={{width: '40px', height: '40px',marginRight: "20px",marginLeft:"20px"}} strokeWidth="4" />
								<div style={{fontSize:"16px",marginTop:"0px"}}> Buscando dados da reserva... </div>
																				
						</div>
						
						<Skeleton width="100%" height="4rem" ></Skeleton>
						<br />
						<Skeleton width="100%" height="4rem" ></Skeleton>
						<br />
						<Skeleton width="100%" height="4rem" ></Skeleton>
						<br />
						<Skeleton width="100%" height="4rem" ></Skeleton>
						
					</>				
				}
				
				{/* CONTENT  */}
				{!loadingData &&
				<>
				
						<div id="topSection" className="navigationContentWrapper flex-row justify-center align-items-start" style={{maxWidth:"1280px",marginTop:"0",width:"100%",flex:1,gap:"1rem"}}>


							<div className="resultsWrapper flex-column justify-center align-items-center" style={{gap:"1rem",flex:1}}>

								{/* BOOKING SUMMARY START */}  
								<div id="bookingData" className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

									<div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
										
										<div className="bookingDetails_title">Dados da reserva</div>

										<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

											{/* Status reserva */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Status da reserva</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
													
													{bookingStatus == 0 && <Message severity="warn" text="Aguardando Confirmação" />}
													{bookingStatus == 1 && <Message severity="success" text="Confirmada" />}
													{bookingStatus == 2 && <Message severity="error" text="Cancelada pelo Sistema" />}
													{bookingStatus == 3 && <Message severity="error" text="Cancelada pela Agência" />}

													{history.length > 1 && <Button icon="pi pi-history" style={{marginLeft:"0.5rem"}} tooltip='Histórico de alterações de Status' outlined onClick={() => setBookingHistoryPanel(!bookingHistoryPanel)} />}

													</div>
											
											</div>

											{/* Historico Status reserva */}
											{bookingHistoryPanel &&
											<>
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>

												{history.map((item, index) => {

													const severity = item.status == 0 ? 'warn' : item.status == 1 ? 'success' : item.status == 2 ? 'error' : item.status == 3 ? 'error' : 'info';

													return (<>
													<div className="bookingDetails_wrapper_item_label tAlignC">
															<Message severity={severity} text={item.status == 0 ? "Aguardando confirmação" : item.status == 1 ? "Confirmada" : item.status == 2 ? "Cancelada pelo Sistema" : item.status == 3 ? "Cancelada pela Agência" : "Info"} /><br />
															<small>{moment(item.date).format('DD/MM/YYYY')}</small>
													</div>	
													{index < history.length - 1 && <div className="bookingDetails_wrapper_item_line flex-1"></div>}
													</>);	

												})}


											</div>		
											</>
											}								

											{/* Status pagamento */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Status do pagamento</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">

														{(paymentStatus == 0 && bookingStatus == 1) && <Message severity="warn" text="Aguardando pagamento" />}
														{(paymentStatus == 1 && bookingStatus == 1) && <Message severity="success" text="Pagamento confirmado" />}
														{(paymentStatus == 2 && bookingStatus == 3) && <Message severity="warn" text="Aguardando reembolso" />}
														{(paymentStatus == 3 && bookingStatus == 3) && <Message severity="success" text="Reembolso confirmado" />}
														{(bookingStatus == 2) && <Message severity="error" text="Reserva cancelada" />}		
														{(bookingStatus == 3 && paymentStatus == 0) && <Message severity="error" text="Reserva cancelada" />}		
														{(bookingStatus == 3 && paymentStatus == 1) && <Message severity="success" text="Pagamento confirmado" />}

														{historyPayment.length > 1 && <Button icon="pi pi-history" style={{marginLeft:"0.5rem"}} tooltip='Histórico de Status de pagamento' outlined onClick={() => setPaymentHistoryPanel(!paymentHistoryPanel)} />}
														
														{paymentStatus == 0 && <><br /><small style={{color:"#333"}}>Data limite {booking?.deadlines?.freeCancelDateDisplay || "-"}</small></>}
														{/*<small style={{color:"#FF0000"}}>Data limite 04/09/2025</small>*/}	
												</div> 
												{/*<div className="bookingDetails_wrapper_item_value"><Message severity="success" text="Confirmada" /></div>
												<div className="bookingDetails_wrapper_item_value"><Message severity="warn" text="Aguardando pagamento" /></div>
												<div className="bookingDetails_wrapper_item_value"><Message severity="error" text="Aguardando Estorno" /></div>
												<div className="bookingDetails_wrapper_item_value"><Message severity="info" text="Reembolso confirmado" /></div>*/}
											</div>			

											{/* Historico Status pagamento */}
											{paymentHistoryPanel &&
											<>
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>

												{historyPayment.map((item, index) => {

													const severity = item.status == 0 ? 'warn' : item.status == 1 ? 'success' : item.status == 2 ? 'error' : item.status == 3 ? 'error' : 'info';

													// Add <div className="bookingDetails_wrapper_item_line flex-1"></div> on all except last item	

													return (<>
													<div className="bookingDetails_wrapper_item_label tAlignC">
															<Message severity={severity} text={item.status == 0 ? "Aguardando confirmação" : item.status == 1 ? "Confirmado" : item.status == 2 ? "Falha" : item.status == 3 ? "Falha" : "Info"} /><br />
															<small>{moment(item.date).format('DD/MM/YYYY')}</small>
													</div>	
													{index < historyPayment.length - 1 && <div className="bookingDetails_wrapper_item_line flex-1"></div>}
													</>);

												})}

											</div>
											</>	
											}																		

											{/* Agência  IF MASTER */}
											{masterUser && (
												<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
													<div className="bookingDetails_wrapper_item_label">Agência</div>
													<div className="bookingDetails_wrapper_item_line flex-1"></div>
													<div className="bookingDetails_wrapper_item_value tAlignR">
														
														{reservationAll?.agency?.companyName || "Não definido"}<br />
														<small style={{color:"#333"}}>Nome fantasia: {reservationAll?.agency?.tradingName || "Não definido"}</small>

													</div>
												</div>
											)}

											{/* Código da reserva */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Código da reserva</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
													
														{(paymentStatus == 0 && bookingStatus == 1) && <Message severity="warn" text="Aguardando pagamento" />}
														{(paymentStatus == 1 && bookingStatus == 1) && <>{booking?.reservationCode || '-'}</>}
														{(paymentStatus == 2 && bookingStatus == 3) && <Message severity="error" text="Reserva cancelada" />}
														{(paymentStatus == 3 && bookingStatus == 3) && <Message severity="error" text="Reserva cancelada" />}		
														{(bookingStatus == 2) && <Message severity="error" text="Reserva cancelada" />}		
														{(bookingStatus == 3 && paymentStatus == 0) && <Message severity="error" text="Reserva cancelada" />}		
														{(bookingStatus == 3 && paymentStatus == 1) && <Message severity="error" text="Reserva cancelada" />}

													</div>
											</div>

											{/* Voucher */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Voucher da reserva</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">
												{(paymentStatus === 0 && bookingStatus === 1) && <Message severity="warn" text="Aguardando pagamento" />}

												{(paymentStatus === 1 && bookingStatus === 1 && booking?.voucher?.available) && (
												<Button
													label="Baixar PDF do Voucher"
													icon="pi pi-file-pdf"
													className="p-button-outlined p-button-secondary"
													loading={loadingQuote}
													onClick={handleDownloadVoucher}
												/>
												)}

												{(paymentStatus === 1 && bookingStatus === 1 && booking?.voucher?.available === false) && (
												<Message severity="info" text="Voucher indisponível" />
												)}

												{(paymentStatus === 2 && bookingStatus === 3) && <Message severity="error" text="Reserva cancelada" />}
												{(paymentStatus === 3 && bookingStatus === 3) && <Message severity="error" text="Reserva cancelada" />}
												{(bookingStatus === 2) && <Message severity="error" text="Reserva cancelada" />}
												{(bookingStatus === 3 && paymentStatus === 0) && <Message severity="error" text="Reserva cancelada" />}
												{(bookingStatus == 3 && paymentStatus == 1) && <Message severity="error" text="Reserva cancelada" />}
											</div>
											</div>

											
											{/* Data de hospedagem */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Data de hospedagem</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">
												{booking?.period?.display || "-"}
											</div>
											</div>

											{/* Data limite do cancelamento */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Data limite do cancelamento</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">
												{booking?.deadlines?.freeCancelDateDisplay || "-"}
												{booking?.deadlines?.freeCancelDateDisplay && (
												<>
													<br />
													<small style={{color:"#333"}}>Cancelamento gratuito, sem penalidade</small>
												</>
												)}
											</div>
											</div>


											{/* Data do cancelamento REAL */}
											{masterUser &&
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Data limite cancelamento Fornecedor</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.deadlines?.providerFreeCancelDate?.display || "-"} <br /><small style={{color:"#333"}}>Cancelamento Gratuito, sem penalidade</small></div>
											</div>
											}													


											{/* Código Interno */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Código Interno</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">{reservationAll?.internalCode || "-"}</div>
											</div>

											{/* Provider */}
											{masterUser &&
											<>
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Provedor da reserva</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">{reservationAll?.provider?.serviceName || "-"}</div>
											</div>											
											</>
											}

										</div>

										</div>

									</div> 

									</div>
								</div>
								{/* BOOKING SUMMARY END */}  

								{/* BOOKING  CANCELATION INFO START --- IF Booking status is 2 or 3 */}  
								{(bookingStatus == 2 || bookingStatus == 3) &&
								<>
									<div id="bookingCancellationInfo" className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background:"#ffe7e6",border:"solid #ff5757"}}>

										<div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

										<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

											<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
											
											<div className="bookingDetails_title">Dados do Cancelamento</div>

											<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>


												{/* Data do cancelamento */}
												<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
													<div className="bookingDetails_wrapper_item_label">Data do cancelamento</div>
													<div className="bookingDetails_wrapper_item_line flex-1"></div>
													<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.cancellation?.cancelledAtDisplay || '-'} {booking?.cancellation?.afterDeadline && <><br /><small style={{color:"red"}}>Depois do prazo limite</small></>} </div>
													{/*<div className="bookingDetails_wrapper_item_value tAlignR">03/09/2025 às 12:45 <br /><small style={{color:"#333"}}>Antes do prazo limite</small></div>
													<div className="bookingDetails_wrapper_item_value tAlignR">03/09/2025 às 12:45 <br /><small style={{color:"red"}}>Depois do prazo limite</small></div>*/}
												</div>

												{/* Data do cancelamento */}
												<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
													<div className="bookingDetails_wrapper_item_label">Data limite do cancelamento</div>
													<div className="bookingDetails_wrapper_item_line flex-1"></div>
													<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.deadlines?.freeCancelDateDisplay || '-'} <br /><small style={{color:"#333"}}>Cancelamento Gratuito, sem penalidade</small></div>
													{/*<div className="bookingDetails_wrapper_item_value tAlignR">03/09/2025 às 12:45 <br /><small style={{color:"#333"}}>Antes do prazo limite</small></div>
													<div className="bookingDetails_wrapper_item_value tAlignR">03/09/2025 às 12:45 <br /><small style={{color:"red"}}>Depois do prazo limite</small></div>*/}
												</div>


												{/* Data do cancelamento REAL */}
												{masterUser &&
												<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
													<div className="bookingDetails_wrapper_item_label">Data limite cancelamento Fornecedor</div>
													<div className="bookingDetails_wrapper_item_line flex-1"></div>
													<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.deadlines?.providerFreeCancelDate?.display || '-'} <br /><small style={{color:"#333"}}>Cancelamento Gratuito, sem penalidade</small></div>
												</div>
												}													

												{/* Cancelled by */}
												<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
													<div className="bookingDetails_wrapper_item_label">Cancelada por</div>
													<div className="bookingDetails_wrapper_item_line flex-1"></div>
													<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.cancellation?.cancelledBy || '-'}</div>										
												</div>

												{/* Cancel reason */}
												<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
													<div className="bookingDetails_wrapper_item_label">Motivo do cancelamento</div>
													<div className="bookingDetails_wrapper_item_line flex-1"></div>
													<div className="bookingDetails_wrapper_item_value tAlignR"><small>{booking?.cancellation?.cancelledByReason || 'Nenhum motivo fornecido.'}</small></div>
												</div>

												{/* Cancel reason description */}
												<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
													<div className="bookingDetails_wrapper_item_label">Detalhamento do motivo do cancelamento</div>
													<div className="bookingDetails_wrapper_item_line flex-1"></div>
													<div className="bookingDetails_wrapper_item_value tAlignR"><small>{booking?.cancellation?.cancelledByReasonDescription || 'Nenhuma informação extra fornecida.'}</small></div>
												</div>

											</div>

											</div>

										</div> 

										</div>
									</div>
								</>
								}
								{/* BOOKING CANCELATION INFO END */}  

								{/* HOTEL DETAILS - START */}							
								<div id="selectionSummary" className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

									<div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
										
										<div className="bookingDetails_title">Resumo das seleções</div>

										<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

											{/* Destino */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Destino selecionado</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">{reservationAll?.destination?.display || "-"}</div>
											</div>

											{/* Hotel */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Hotel selecionado</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">{hotel?.name || "-"}</div>
											</div>

											{/* Data */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Data de hospedagem</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.period?.display || "-"}</div>
											</div>

											{/* Diárias */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Número de diárias</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.period?.nights || "-"}</div>
											</div>

											{/* Hóspedes */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Número de hóspedes</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">{hotel?.rooms?.[0]?.guestsSummary || "-"}</div>
											</div>

											{/* Quarto */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem",marginTop:"2rem"}}>
											<div className="bookingDetails_wrapper_item_label">Quarto 1</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">{hotel?.rooms?.[0]?.name || "-"}</div>
											</div>  

											{/* Hóspedes do quarto */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Hóspedes</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">{hotel?.rooms?.[0]?.guestsSummary || "-"}</div>
											</div>

											{/* Extras (estático) */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Extras</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">{hotel?.rooms?.[0]?.extras?.[0] || "-"}</div>
											</div>  

											{/* Cancelamento (estático) */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Cancelamento</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">
												Cancelamento Gratuito <label style={{color:"#878787"}}>até {booking?.deadlines?.freeCancelDateDisplay || "-"}</label>
											</div>
											</div>

											{/* Tarifas cobradas no local */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label tAlignL">Tarifas cobradas no local</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">

												{(() => {
												const rawFees = hotel?.rooms?.[0]?.localCollectedFees;
												const fees = Array.isArray(rawFees) ? rawFees : []; // <- garante array

												return fees.length > 0 ? (
													fees.map((fee, index) => {
													const amount = Number(fee?.amount ?? 0);
													const currency = fee?.currency ?? 'BRL';
													const description = fee?.description ?? 'Tarifa';

													// formatação mais segura
													const formatted = Number.isFinite(amount)
														? new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(amount)
														: `${currency} 0,00`;

													return (
														<div className="bookingDetails_wrapper_item_value_item tAlignR" key={fee?.id ?? index}>
														{description}: {formatted}
														</div>
													);
													})
												) : (
													<div className="bookingDetails_wrapper_item_value_item tAlignR">
													<small style={{color:"#333"}}>Nenhuma tarifa adicional</small>
													</div>
												);
												})()}

											</div>
											</div>

											{/* Solicitacoes especiais no quarto */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label tAlignL">Solicitações especiais no quarto</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">
												<div className="bookingDetails_wrapper_item_value_item tAlignR"><small style={{color:"#333"}}>{hotel?.rooms?.[0]?.specialRequests || "-"}</small></div>
											</div>
											</div>

										</div>

										{/* TOTALS */}
										<div className="bookingTotals" style={{marginTop:"4rem",width:"100%",maxWidth:"900px"}}>
											<div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%", gap:"0.5rem"}}>
											<div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{padding:"0.5rem", gap:"0.5rem", width:"100%"}}>
												<div className="flex-column justify-center align-items-right w100">

												{/* Total da hospedagem */}
												<div className="bookingTotals_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
													<div className="bookingTotals_wrapper_item_label">Total da hospedagem</div>
													<div className="bookingTotals_wrapper_item_line flex-1"></div>
													<div className="bookingTotals_wrapper_item_value tAlignR">
													{totals?.payWithFeesDisplay || "-"}
													</div>
												</div>

												{/* Inclui impostos e taxas */}
												<div className="resultsCard_details__prices___dailyPrice w100" style={{color: "#878787", fontFamily: "Titillium Web", fontSize: "0.85rem", fontWeight: 400, lineHeight: "1.625rem", letterSpacing: "0.02875rem", textAlign:"right"}}>
													inclui impostos e taxas
												</div>

												{/* Pagar na reserva */}
												<div className="resultsCard_details__prices___dailyPrice w100" style={{color:"#878787", fontFamily: "Poppins", fontSize: "1rem", fontWeight: 400, lineHeight: "2.12938rem", textAlign:"right", marginTop:"1rem"}}>
													<span style={{fontSize:"0.85rem"}}>Pagar após reserva </span>
													{totals?.payNowDisplay || "-"}
												</div>

												{/* Pagar na propriedade */}
												<div className="resultsCard_details__prices___dailyPrice w100" style={{color:"#878787", fontFamily: "Poppins", fontSize: "1rem", fontWeight: 400, lineHeight: "2.12938rem", textAlign:"right", marginTop:"1rem"}}>
													<span style={{fontSize:"0.85rem"}}>Pagar na propriedade </span>
													{totals?.payAtPropertyDisplay || "-"}
													<div className="resultsCard_details__prices___dailyPrice w100" style={{color: "rgb(183 183 183)", lineHeight:"1rem", fontFamily: "Titillium Web", fontSize: "0.75rem", fontWeight:600, textAlign:"right"}}>
													Os impostos e/ou taxas a serem pagos na propriedade serão pagos sempre na moeda local.
													</div>
												</div>

												</div>   
											</div>
											</div>
										</div>
										{/* TOTALS END */}

										</div>

									</div> 

									</div>
								</div>
								{/* HOTEL DETAILS - END */}  

								{/* HOTEL PAYMENT RESPONSIBLE - START */}  						
								<div id="paymentResponsibleData" className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

									<div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>

										<div className="bookingDetails_title flex-row justify-between align-items-center" style={{gap:"1rem"}}>
											<div>Responsável pelo pagamento</div>

											{paymentResponsibleHistory.length > 1 &&
												<Button outlined size="small" icon="pi pi-history" tooltip='Histórico de responsável pelo pagamento' onClick={() => setPaymentResponsibleHistoryPanel(!paymentResponsibleHistoryPanel)} />
											}

										</div>

										<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

											{/* Nome e perfil */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Nome completo</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">

												{responsiblePayer?.fullName || "-"} <br />
												<small style={{color:"#333"}}>{responsiblePayer?.isForeigner ? "É estrangeiro" : "É brasileiro"}</small><br />
												<small style={{color:"#333"}}>{responsiblePayer?.isOneOfGuests ? "É um dos hóspedes" : "Não é um dos hóspedes"}</small>


											</div>
											</div>

											{/* Documento */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Documento</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">{responsiblePayer?.document?.type && responsiblePayer?.document?.number ? `${responsiblePayer.document.type}: ${responsiblePayer.document.type.toLowerCase() == "cpf" ? maskCPF(responsiblePayer.document.number) : responsiblePayer.document.number}` : "-"}</div>
											</div>

											{/* Data de nascimento */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
											<div className="bookingDetails_wrapper_item_label">Data de Nascimento</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">{responsiblePayer?.birthDateDisplay || "-"} <br /><small style={{color:"#333"}}>{responsiblePayer?.age || "-"} anos</small></div>
											</div>

											{/* Email */}
											<div className="bookingDetails_wrapper_item ...">
											<div className="bookingDetails_wrapper_item_label">Email</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">
												{responsiblePayer?.email || "-"}
											</div>
											</div>

											{/* Telefone */}
											<div className="bookingDetails_wrapper_item ...">
											<div className="bookingDetails_wrapper_item_label">Telefone</div>
											<div className="bookingDetails_wrapper_item_line flex-1"></div>
											<div className="bookingDetails_wrapper_item_value tAlignR">
												{responsiblePayer?.phone || "-"}
											</div>
											</div>											

											{paymentResponsibleHistoryPanel && (
											<>
												<h3>Histórico de responsáveis pelo pagamento</h3>
												<div className="bookingDetails_wrapper_item flex-row ...">
												<div className="bookingDetails_wrapper_item_label">Nome completo</div>
												<div className="bookingDetails_wrapper_item_label">Documento</div>
												<div className="bookingDetails_wrapper_item_label">Data de Nascimento</div>
												</div>

												{(responsiblePayer?.history || []).map((h, idx) => (
												<div key={idx} className="bookingDetails_wrapper_item flex-row ...">
													<div className="bookingDetails_wrapper_item_label">{h.fullName || "-"}</div>
													<div className="bookingDetails_wrapper_item_label">{h.document || "-"}</div>
													<div className="bookingDetails_wrapper_item_value tAlignR">{h.birthDateDisplay || "-"}</div>
												</div>
												))}
											</>
											)}


											<div className="bookingDetails_wrapper_item w100" style={{gap:"1rem"}}>
												{blockPayment === true && (
													<div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"1rem",padding:"0.5rem"}}>
														<img src={iconResponsibleWarning} alt="Aviso de antecipação de comisssão" style={{width:"2.5rem",height:"auto"}} />
														<div className="advanceComissionWarningSmall">Não será possível realizar o pagamento pois o responsável pelo pagamento não é um dos hóspedes. Você pode entrar em contato com o suporte para solicitar a liberação ou alterar o responsável pelo pagamento.</div>
													</div>
												)}		
											</div>									


										</div>
						


										</div>

									</div> 

									</div>
								</div> 
								{/* HOTEL PAYMENT RESPONSIBLE - END */}  

								{/* HOTEL HOSTS - START */}  						
								<div id="guestsData" className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

									<div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>

										<div className="bookingDetails_title">Relação de Hóspedes</div>

										<div className="bookingDetails_wrapper flex-column ..." style={{gap:"1rem",maxWidth:"900px"}}>
										{guests.map((g) => (
											<React.Fragment key={g.index}>
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem",marginTop:"2rem"}}>
												<div className="bookingDetails_wrapper_item_label" style={{fontWeight:"bold"}}>
												Hóspede {g.index} <small>({g.type === 'adult' ? 'Adulto' : 'Criança'})</small>
												</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
												<small style={{color:"#333"}}>{g.isBookingHolder ? 'Responsável pela reserva' : ''}</small>
												</div>
											</div>

											<div className="bookingDetails_wrapper_item flex-row ...">
												<div className="bookingDetails_wrapper_item_label">Nome completo</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{g.fullName || "-"}</div>
											</div>

											<div className="bookingDetails_wrapper_item flex-row ...">
												<div className="bookingDetails_wrapper_item_label">Documento</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
												{g?.document?.type && g?.document?.number ? `${g.document.type}: ${g.document.type.toLowerCase() == "cpf" ? maskCPF(g.document.number) : g.document.number}` : "-"}
												</div>
											</div>

											<div className="bookingDetails_wrapper_item flex-row ...">
												<div className="bookingDetails_wrapper_item_label">Data de nascimento</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{g.birthDateDisplay || "-"} <br /><small style={{color:"#333"}}>{g.age} anos</small></div>
											</div>

											{g.type === 'child' &&
											<>
											<div className="bookingDetails_wrapper_item flex-row ...">
												<div className="bookingDetails_wrapper_item_label">Idade no Checkout</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR"><small style={{color:"#333"}}>{g.ageAtCheckout || "-"} anos</small></div>
											</div>											
											</>
											}

											</React.Fragment>
										))}
										</div>

										</div>

									</div> 

									</div>
								</div>
								{/* HOTEL HOSTS - END */}  

								{/* BOOKING PAYMENT INFO START --- IF Booking status is 2 or 3 */}  
								<div id="paymentData" className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background:paymentStatus == 0 ? "#fff2e2" : (paymentStatus == 1 ? "#e2fff2" : paymentStatus == 2 ? "#fff2e2" : paymentStatus == 3 ? "#e2fff2" : "#fff"),border:paymentStatus === 0 ? "solid #cc8925" : (paymentStatus == 1 ? "solid #1ea97c" : paymentStatus == 2 ? "solid #cc8925" : paymentStatus == 3 ? "solid #1ea97c" : "#fff")}}>

									<div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
										
										<div className="bookingDetails_title">Informações do Pagamento</div>

											{/* Aguardando Pagamento */}
											{paymentStatus == 0 &&
											<>
												<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

													{/* Status pagamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Status do pagamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">

															{(bookingStatus == 2) && <Message severity="error" text="Reserva cancelada" />}		
															{(bookingStatus == 1) && <Message severity="warn" text="Aguardando pagamento" />}		
															{(bookingStatus == 3) && <Message severity="error" text="Reserva cancelada" />}		
																
														</div>
													</div>	

													{/* Restrições */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Restrições</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR"><small style={{color:"#333"}}>Pagamento com cartão de crédito limitado ao responsável pelo pagamento. <br /> O responsável deve estar entre os hóspedes.</small></div>
													</div>

													{/* Data do cancelamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Data limite do pagamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.deadlines?.freeCancelDateDisplay || "-"} <br /><small style={{color:"#333"}}>Será cancelado após essa data se não for pago</small></div>
													</div>

													{/* Data do cancelamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Data limite do cancelamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.deadlines?.freeCancelDateDisplay || "-"} <br /><small style={{color:"#333"}}>Cancelamento Gratuito, sem penalidade</small></div>
														{/*<div className="bookingDetails_wrapper_item_value tAlignR">03/09/2025 às 12:45 <br /><small style={{color:"#333"}}>Antes do prazo limite</small></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">03/09/2025 às 12:45 <br /><small style={{color:"red"}}>Depois do prazo limite</small></div>*/}
													</div>

 
													{/* Data do cancelamento REAL */}
													{masterUser &&
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Data limite cancelamento Fornecedor</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.deadlines?.providerFreeCancelDate?.display || "-"}<br /><small style={{color:"#333"}}>Cancelamento Gratuito, sem penalidade</small></div>
													</div>
													}											

													{/* Valor a ser pago */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Valor a ser pago</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{formatNumberCurrency(totals?.payNow, 'USD') || "-"}<br /><small style={{color:"#333"}}>Valor convetido com a cotação do dia</small></div>										
													</div>

													{/* Valor para pagamento HOJE */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Valor para pagamento HOJE</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">
															{formatNumberCurrency(totals?.payNowConverted, 'BRL')}
															<br /><small>Em até 12x sem juros no cartão ou a vista no PIX</small>
															<br /><small style={{color:"#333"}}>Valor convertido com dólar a {totals?.payNowConvertedExchangeRate}</small></div>
													</div>

												</div>
											</>
											}

											{/* Pagamento confirmado */}
											{paymentStatus == 1 &&
											<>
												<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

													{/* Status pagamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Status do pagamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">
																<Message severity="success" text="Pagamento confirmado" />
																{latestPayment?.manualConfirmation && <><br /><small style={{color:"#333"}}>Baixado de forma manual</small></>}	
														</div>
													</div>	

													{/* Data do pagamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Data do pagamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{latestPayment?.paidAtDisplay || "-"}</div>
													</div>

													{/* Forma de pagamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Forma de pagamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR"><strong>{latestPayment?.methodLabel || "-"}</strong> em {latestPayment?.installments || 1}x sem juros</div>
													</div>													

													{/* Data do cancelamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Data limite do cancelamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.deadlines?.freeCancelDateDisplay || "-"} <br /><small style={{color:"#333"}}>Cancelamento Gratuito, sem penalidade</small></div>
													</div>

													{/* Data do cancelamento REAL */}
													{masterUser &&
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Data limite cancelamento Fornecedor</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.deadlines?.providerFreeCancelDate?.display || "-"} <br /><small style={{color:"#333"}}>Cancelamento Gratuito, sem penalidade</small></div>
													</div>
													}											

													{/* Original value */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Valor da reserva</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{formatNumberCurrency(latestPayment?.originalAmount?.amount, 'USD')}</div>										
													</div>

													{/* Payment value */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Valor pago</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">
														{formatNumberCurrency(latestPayment?.conversion?.amountPaidBRL, 'BRL')} {latestPayment.multiPayment && <small style={{color:"#6e6e6e"}}>de {formatNumberCurrency(latestPayment.multiPaymentTotalAmount, 'BRL')}</small>}
															{latestPayment.method == "cc" && (<><br /><small>Em {latestPayment.installments}x sem juros no cartão</small></>)}
															<br /><small style={{color:"#333"}}>Valor convertido com dólar a {latestPayment?.conversion?.exchangeRateBRL}</small></div>
													</div>

													{/* Multi Payment info */}
													{latestPayment.multiPayment &&
													<>
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Informações extras</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR"  style={{maxWidth:"50%"}}>
															Pagamento único para múltiplas reservas.
															<br /><small style={{color:"#333"}}>{latestPayment?.extraInfo || "-"}</small></div>
													</div>	
													</>
													}


												</div>
											</>
											}											

											{/* Aguardando Estorno */}
											{paymentStatus == 2 &&
											<>
												<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

													{/* Status pagamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Status do pagamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">
															{(bookingStatus == 3) && <Message severity="warn" text="Aguardando reembolso" />}
															{(bookingStatus == 2) && <Message severity="error" text="Reserva cancelada" />}	
														</div>
													</div>	

													{/* Data do pagamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Data do cancelamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.cancellation?.cancelledAtDisplay || "-"}</div>
													</div>

													{/* Forma de pagamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Forma de pagamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR"><strong>{latestPayment?.methodLabel || "-"}</strong> em {latestPayment?.installments || 1}x sem juros</div>
													</div>													

													{/* Original value */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Valor da reserva</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{formatNumberCurrency(latestPayment?.originalAmount?.amount, 'USD')}</div>										
													</div>

													{/* Payment value */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Valor pago</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">
														{formatNumberCurrency(latestPayment?.conversion?.amountPaidBRL, 'BRL')} {latestPayment.multiPayment && <small style={{color:"#6e6e6e"}}>de {formatNumberCurrency(latestPayment.multiPaymentTotalAmount, 'BRL')}</small>}
															{latestPayment.method == "cc" && (<><br /><small>Em {latestPayment.installments}x sem juros no cartão</small></>)}
															<br /><small style={{color:"#333"}}>Valor convertido com dólar a {latestPayment?.conversion?.exchangeRateBRL}</small></div>
													</div>

													{/* Multi Payment info */}
													{latestPayment.multiPayment &&
													<>
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Informações extras</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR"  style={{maxWidth:"50%"}}>
															Pagamento único para múltiplas reservas.
															<br /><small style={{color:"#333"}}>{latestPayment?.extraInfo || "-"}</small></div>
													</div>	
													</>
													}

												</div>
											</>
											}													

											{/* Reembolso confirmado */}
											{paymentStatus == 3 &&
											<>
												<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

													{/* Status pagamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Status do pagamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">
															<Message severity="success" text="Reembolso confirmado" />
														</div>
													</div>	

													{/* Data do reembolso */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Data do reembolso</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{refund?.refundedAtDisplay || "-"}</div>
													</div>


													{/* Data do cancelamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Data do cancelamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{booking?.cancellation?.cancelledAtDisplay || "-"}</div>
													</div>

													{/* Forma de pagamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Forma de pagamento</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR"><strong>{latestPayment?.methodLabel || "-"}</strong> em {latestPayment?.installments || 1}x sem juros</div>
													</div>													

													{/* Original value */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Valor da reserva</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{formatNumberCurrency(latestPayment?.originalAmount?.amount, 'USD')}</div>										
													</div>

													{/* Payment value */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Valor pago</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">
														{formatNumberCurrency(latestPayment?.conversion?.amountPaidBRL, 'BRL')} {latestPayment.multiPayment && <small style={{color:"#6e6e6e"}}>de {formatNumberCurrency(latestPayment.multiPaymentTotalAmount, 'BRL')}</small>}
															{latestPayment.method == "cc" && (<><br /><small>Em {latestPayment.installments}x sem juros no cartão</small></>)}
															<br /><small style={{color:"#333"}}>Valor convertido com dólar a {latestPayment?.conversion?.exchangeRateBRL}</small></div>
													</div>

													{/* Multi Payment info */}
													{latestPayment.multiPayment &&
													<>
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Informações extras</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR"  style={{maxWidth:"50%"}}>
															Pagamento único para múltiplas reservas.
															<br /><small style={{color:"#333"}}>{latestPayment?.extraInfo || "-"}</small></div>
													</div>	
													</>
													}

												</div>
											</>
											}													

										</div>

									</div> 

									</div>
								</div>
								{/* BOOKING PAYMENT INFO END */}

								{/* BOOKING REFUND PAYMENT INFO START --- IF Booking status is 2 or 3 */}  
								{(bookingStatus == 3 && refundStatus != 0) &&
								<>
								<div id="paymentRefundData" className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background:refundStatus === 0 ? "#fff2e2" : (refundStatus === 1 ? "#fff2e2" : refundStatus === 2 || refundStatus === 4 ? "#e2fff2" : refundStatus === 3 ? "#fff2e2" : "#fff"),border:refundStatus === 0 ? "solid #cc8925" : (refundStatus === 1 ? "solid #cc8925" : refundStatus === 2 || refundStatus === 4 ? "solid #1ea97c" : refundStatus === 3 ? "solid #cc8925" : "#fff")}}>

									<div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
										
										<div className="bookingDetails_title">Informações do Reembolso</div>

											{/* Aguardando reembolso */}
											{(refundStatus == 1 || refundStatus == 3) &&
											<>
												<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

													{/* Status reembolso */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Status do reembolso</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">
																<Message severity="warn" text="Aguardando reembolso" />
																<br />
																{booking?.refund?.createdManually && <small style={{color:"#333"}}>Reembolso criado manualmente.</small>}
														</div>
													</div>	

													{/* Restrições */}
													{masterUser &&
													<>
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Atenção</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR"><small style={{color:"#333"}}>Antes de efetivar o reembolso, verifique se a comissão foi paga para a Agência.<br />Se foi pago, o reembolso deve ser feito retirando o valor da comissão. <br /> A taxa de 3,5% poderá ou não ser retirada no momento da efetivação.</small></div>
													</div>
													</>
													}

													{/* refund amount */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Valor a ser reembolsado</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">															
															{formatNumberCurrency(refund?.refundAmountBRL || 0, 'BRL')}
															<br />
															{latestPayment.method == "cc" && <small style={{color:"#333"}}>Valor será reembolsado no cartão de crédito utilizado.</small>}	
															{latestPayment.method != "cc" && <small style={{color:"#333"}}>Valor será reembolsado na conta PIX fornecida.</small>}	
														</div>
													</div>
													{/*  refund details */}

													{/* Informacoes de pagamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center" style={{gap:"1rem",width:"50%"}}>
														<div className="bookingDetails_wrapper_item_value">

															<h3>Detalhamento do reembolso</h3>

															<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
																<div className="bookingDetails_wrapper_item_label">Descrição</div>
																<div className="bookingDetails_wrapper_item_label">Valor</div>									
															</div>

															<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
																<div className="bookingDetails_wrapper_item_label">Valor Total</div>
																<div className="bookingDetails_wrapper_item_label">{formatNumberCurrency(refund?.amountBRL || 0, 'BRL')}</div>
															</div>

															<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
																<div className="bookingDetails_wrapper_item_label fColorRed">Taxa {Number(refund?.refundTaxPercentage) || '-'}%</div>
																<div className="bookingDetails_wrapper_item_label fColorRed">({formatNumberCurrency(refund?.refundTaxAmountBRL, 'BRL')})</div>
															</div>

															{refund?.removeComission &&
															<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
																<div className="bookingDetails_wrapper_item_label fColorRed">Comissão</div>
																<div className="bookingDetails_wrapper_item_label fColorRed">({formatNumberCurrency(refund?.refundComissionAmount, 'BRL')})</div>
															</div>
															}

															<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
																<div className="bookingDetails_wrapper_item_label bold">Valor Reembolso</div>
																<div className="bookingDetails_wrapper_item_label bold">{formatNumberCurrency(refund?.refundAmountBRL || 0, 'BRL')}</div>
															</div>	

															<small style={{color:"#333",fontSize:"0.9rem"}}>Ao efetivar o reembolso, você pode retirar, se desejar, o desconto da taxa de 3,5% e/ou da comissão.</small>																																												

														</div>
													</div>										

												</div>
											</>
											}

											{/* Reembolso confirmado */}
											{(refundStatus == 2 || refundStatus == 4) &&
											<>
												<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

													{/* Status pagamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Status do reembolso</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">
																<Message severity="success" text="Reembolso confirmado" />
																<br />
																{refundStatus == 4 && <small style={{color:"#333"}}>Baixado de forma manual</small>}	
														</div>
													</div>	

													{/* Data do reembolso */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Data do reembolso</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">{refund?.refundedAtDisplay || '-'}</div>
													</div>

													{/* Forma de reembolso */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Forma de reembolso</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR"><strong>{latestPayment?.methodLabel || "-"}</strong></div>
													</div>													

													{/* refund amount */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
														<div className="bookingDetails_wrapper_item_label">Valor reembolsado</div>
														<div className="bookingDetails_wrapper_item_line flex-1"></div>
														<div className="bookingDetails_wrapper_item_value tAlignR">															
															{formatNumberCurrency(refund?.refundAmountBRL || 0, 'BRL')}
															{latestPayment?.method == "cc" && <><br /><small style={{color:"#333"}}>Valor foi reembolsado no cartão de crédito utilizado.</small></>}	
															{latestPayment?.method != "cc" && <><br /><small style={{color:"#333"}}>Valor foi reembolsado na conta PIX fornecida.</small></>}	
														</div>
													</div>

													{/* Informacoes de pagamento */}
													<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center" style={{gap:"1rem",width:"50%"}}>
														<div className="bookingDetails_wrapper_item_value">

															<h3>Detalhamento do reembolso</h3>

															<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
																<div className="bookingDetails_wrapper_item_label">Descrição</div>
																<div className="bookingDetails_wrapper_item_label">Valor</div>									
															</div>

															<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
																<div className="bookingDetails_wrapper_item_label">Valor Total</div>
																<div className="bookingDetails_wrapper_item_label">{formatNumberCurrency(refund?.amountBRL || 0, 'BRL')}</div>
															</div>

															<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
																<div className="bookingDetails_wrapper_item_label fColorRed">Taxa {Number(refund?.refundTaxPercentage) || '-'}%</div>
																<div className="bookingDetails_wrapper_item_label fColorRed">({formatNumberCurrency(refund?.refundTaxAmountBRL, 'BRL')})</div>
															</div>

															{refund?.removeComission &&
															<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
																<div className="bookingDetails_wrapper_item_label fColorRed">Comissão</div>
																<div className="bookingDetails_wrapper_item_label fColorRed">({formatNumberCurrency(refund?.refundComissionAmount, 'BRL')})</div>
															</div>
															}

															<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
																<div className="bookingDetails_wrapper_item_label bold">Valor Reembolso</div>
																<div className="bookingDetails_wrapper_item_label bold">{formatNumberCurrency(refund?.refundAmountBRL || 0, 'BRL')}</div>
															</div>	

														</div>
													</div>			

												</div>
											</>
											}											

										</div>

									</div> 

									</div>
								</div>
								</>
								}
								{/* BOOKING REFUND PAYMENT INFO END */}								
								
								{/* BOOKING PAYMENT COMISSION INFO START --- IF Booking status is  3 */}  
								<div id="paymentCommissionData" className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background:comissionStatus == 0 ? "rgba(219, 234, 254, 0.7)" : (comissionStatus == 1 ? "#fff2e2" : comissionStatus == 2 ? "#e2fff2" : comissionStatus == 4 ? "#ffe2e2" : comissionStatus === 3 ? "#e2fff2" : "#fff"),border:comissionStatus == 0 ? "solid #2530ccff" : (comissionStatus === 1 ? "solid #cc8925" : comissionStatus == 2 ? "solid #1ea97c" : comissionStatus == 4 ? "solid #ff5757" : comissionStatus == 3 ? "solid #1ea97c" : "#fff")}}>

									<div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>
									
									{comissionStatus == 0 &&
									<>
									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
										
										<div className="bookingDetails_title">Informações da Comissão</div>

										<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

											{/* CC comission % */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão Cartão de crédito</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission?.percentage?.cc || 0}%</div>										
											</div>

											{/* CC comission % */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão PIX</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission?.percentage?.pix || 0}%</div>										
											</div>											

											{/* Estimated */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão estimada USD</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">													
													{formatNumberCurrency(comission?.estimated?.comissionOriginalAmountCC, 'USD')} (CC) <br />
													{formatNumberCurrency(comission?.estimated?.comissionOriginalAmountPIX, 'USD')} (PIX) <br />
												</div>
											</div>


											{/* Estimated */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão estimada BRL</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
													{formatNumberCurrency(comission?.estimated?.comissionConvertedAmountCC, 'BRL')} (CC) <br />
													{formatNumberCurrency(comission?.estimated?.comissionConvertedAmountPIX, 'BRL')} (PIX) <br />
													<small style={{color:"#333"}}>Partindo da cotação de hoje que é {totals?.payNowConvertedExchangeRate || 0}</small>
												</div>

											</div>

										</div>

										</div>

									</div> 
									</>
									}

									{/* Comission waiting payment */}
									{(comissionStatus == 1) &&
									<>
									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
										
										<div className="bookingDetails_title">Informações da Comissão</div>

										<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

											{/* Status comissão */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Status da comissão</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
														<Message severity="warn" text="Aguardando pagamento" />
												</div>
											</div>	

											{/* Payment Method */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Forma de pagamento</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission?.methodLabel || '-'}</div>										
											</div>
							
											{/* CC comission % */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão {comission?.methodLabel || '-'}</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission.paymentMethod == 'cc' ? comission.percentage.cc : comission.percentage.pix}%</div>										
											</div>

											{/* Payment date  */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Data prevista do pagamento</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission?.predictedPaymentDateDisplay || '-'}</div>										
											</div>
							

											{/* Estimated */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão pendente BRL</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
													{formatNumberCurrency(comission?.pendingBRL, 'BRL')}
													<br /><small style={{color:"#333"}}>Valor convertido com dólar a {comission?.exchangeRate || "-"}</small>	
												</div>

											</div>

										</div>

										</div>

									</div> 
									</>
									}

									{/* Comission paid */}
									{(comissionStatus == 2) &&
									<>
									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
										
										<div className="bookingDetails_title">Informações da Comissão</div>

										<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

											{/* Status comissão */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Status da comissão</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
														<Message severity="success" text="Pagamento confirmado" />
												</div>
											</div>	

											{/* Payment Method */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Forma de pagamento</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission?.methodLabel || '-'}</div>										
											</div>
							
											{/* CC comission % */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão {comission?.methodLabel || '-'}</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission.paymentMethod == 'cc' ? comission.percentage.cc : comission.percentage.pix}%</div>										
											</div>

											{/* Payment date  */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Data do pagamento</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission?.paid?.paidAtDisplay || '-'}</div>										
											</div>
							

											{/* Estimated */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão paga BRL</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
													{formatNumberCurrency(comission?.paid?.paidBRL, 'BRL')}
													<br /><small style={{color:"#333"}}>Valor convertido com dólar a {comission?.exchangeRate || "-"}</small>	
												</div>

											</div>

							
											{/* Info */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Observações</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR"><small style={{color:"#333"}}>{comission?.paid?.observation || '-'}</small></div>										
											</div>


										</div>

										</div>

									</div> 
									</>
									}
									
									{/* Comission antecipated */}
									{(comissionStatus == 3) &&
									<>
									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
										
										<div className="bookingDetails_title">Informações da Comissão</div>

										<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

											{/* Status comissão */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Status da comissão</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
														<Message severity="success" text="Comissão antecipada" />
												</div>
											</div>	

											{/* Payment Method */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Forma de pagamento</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission?.methodLabel || '-'}</div>										
											</div>
							
											{/* CC comission % */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão {comission?.methodLabel || '-'}</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission?.advanceComissionPercentage || '-'}%</div>										
											</div>


											{/* Estimated */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão antecipada BRL</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
													{formatNumberCurrency(comission?.advanceComissionAmount, 'BRL')}
													<br /><small style={{color:"#333"}}>Valor convertido com dólar a {comission?.exchangeRate || "-"}</small>	
												</div>

											</div>

										</div>

										</div>

									</div> 
									</>
									}

									{/* Comission cancelled and booking cancelled by agency */}
									{(comissionStatus == 4) &&
									<>
									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
										
										<div className="bookingDetails_title">Informações da Comissão</div>

										<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

											{/* Status comissão */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Status da comissão</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
														<Message severity="error" text="Comissão cancelada" />
												</div>
											</div>	

											{/* Payment Method */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Forma de pagamento</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission?.methodLabel || '-'}</div>										
											</div>
							
											{/* CC comission % */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão {comission?.methodLabel || '-'}</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission.paymentMethod == 'cc' ? comission.percentage.cc : comission.percentage.pix}%</div>										
											</div>


											{/* Estimated and cancelled */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão cancelada BRL</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
													{formatNumberCurrency(comission?.pendingBRL, 'BRL')}
													<br /><small style={{color:"#333"}}>Valor convertido com dólar a {comission?.exchangeRate || "-"}</small>	
												</div>

											</div>											

										</div>

										</div>

									</div>
									</>
									}

									{/* Comission cancelled, but antecipated and booking cancelled by agency */}
									{(comissionStatus == 5) &&
									<>
									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
										
										<div className="bookingDetails_title">Informações da Comissão antecipada</div>

										<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

											{/* Status comissão */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Status da comissão</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
														<Message severity="error" text="Devolução da comissão deve ser feita pela agência para o cliente" />
												</div>
											</div>	

											{/* Payment Method */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Forma de pagamento</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission?.methodLabel || '-'}</div>										
											</div>
							
											{/* CC comission % */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão {comission?.methodLabel || '-'}</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission.paymentMethod == 'cc' ? comission.percentage.cc : comission.percentage.pix}%</div>										
											</div>


											{/* Estimated and cancelled */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão a ser devolvida BRL</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
													{formatNumberCurrency(refund?.refundComissionAmount, 'BRL')}
												</div>
											</div>

										</div>

										</div>

									</div> 
									</>
									}

									{/* Comission cancelled, but paid and booking cancelled by agency */}
									{(comissionStatus == 6) &&
									<>
									<div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

										<div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
										
										<div className="bookingDetails_title">Informações da Comissão paga</div>

										<div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"900px"}}>

											{/* Status comissão */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Status da comissão</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
														<Message severity="error" text="Devolução da comissão deve ser feita pela agência" />
												</div>
											</div>	

											{/* Payment Method */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Forma de pagamento</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission?.methodLabel || '-'}</div>										
											</div>
							
											{/* CC comission % */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão {comission?.methodLabel || '-'}</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">{comission.paymentMethod == 'cc' ? comission.percentage.cc : comission.percentage.pix}%</div>										
											</div>


											{/* Estimated and cancelled */}
											<div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
												<div className="bookingDetails_wrapper_item_label">Comissão a ser devolvida BRL</div>
												<div className="bookingDetails_wrapper_item_line flex-1"></div>
												<div className="bookingDetails_wrapper_item_value tAlignR">
													{formatNumberCurrency(comission?.pendingBRL, 'BRL')}
													<br /><small style={{color:"#333"}}>Valor convertido com dólar a {comission?.exchangeRate || "-"}</small>	
												</div>

											</div>

										</div>

										</div>

									</div> 
									</>
									}									

									</div>
								</div>
								{/* BOOKING PAYMENT COMISSION INFO END */}  


							</div>

															

						</div>					  

					</>	
				}

			</Box>

			<Toast ref={toast} position="bottom-center" />			
			
			<AlertView
				alert={alert}
				setAlert={setAlert}
				alertTitle={alertTitle}
				alertBody={alertBody}
				alertAction={alertAction}
				scrollBlock={true}				
			/>			

			<ReservationCancelModal
				selectedReservation={selectedReservation}
				reservationData={reservationAll}
				onReloadData={() => executeRetrieveOrder?.()}
				setCancelDialog={setCancelDialog}
				cancelDialog={cancelDialog}
				setAlert={setAlert}
				setAlertTitle={setAlertTitle}
				setAlertBody={setAlertBody}
				onReloadDataList={onReloadDataList}
			/>

			<ReservationPayModal
				payDialog={payDialog}
				setPayDialog={setPayDialog}
				reservationData={reservationAll}              // << passe o objeto que você já tem aberto
				selectedReservation={selectedReservation}      // opcional
				
				// callbacks de recarga (use os que você já usa hoje)
				onReloadData={() => executeRetrieveOrder?.()}
				retrieveReservation={retrieveReservation}
				executeRetrieveOrder={executeRetrieveOrder}
				onReloadDataList={onReloadDataList}

				// reaproveitando o seu esquema de alert
				setAlert={setAlert}
				setAlertTitle={setAlertTitle}
				setAlertBody={setAlertBody}

				key={selectedReservation?.id || 'new'}
			/>			

            </Dialog>	
	</>	
	);
	
}


const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  selectedReservation:store.reservationReducer.selectedReservation,
  masterUser:store.appReducer.masterUser,
  userRights:store.appReducer.userRights
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions, ...ReservationActions, ...OrderActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(ReservationView);	
